import { render, staticRenderFns } from "./TermsListMng.vue?vue&type=template&id=140d8f18&scoped=true"
import script from "./TermsListMng.vue?vue&type=script&lang=js"
export * from "./TermsListMng.vue?vue&type=script&lang=js"
import style0 from "./TermsListMng.vue?vue&type=style&index=0&id=140d8f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d8f18",
  null
  
)

export default component.exports